<template>
  <v-app>
    <v-navigation-drawer
      v-if="this.$route.name != 'Login' && this.$route.name != 'PropostaWeb' && this.$route.name != 'ExportPdf'"
      v-model="drawer"
      enable-resize-watcher
      :mini-variant.sync="mini"
      permanent
      :width="290"
      class="menu"
      app>
      <div class="ui-relative">
        <!-- v-if="!$vuetify.theme.dark" -->
        <div class="text-center">
          <img class="menu__open" @click.stop="toggleMenu()" v-if="!mini" src="./assets/img/logo.png" alt="Logo">
          <img class="menu__icon" v-if="mini" src="./assets/img/logo-icon.png" alt="Logo">
        </div>
        <div class="d-flex justify-center">
          <div :class="!mini ? 'tipo' : 'tipo_small'" class="text-center">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" @click.stop="openDialogDadosCadastrais()" :class="nivelUsuarioApelido !== 'M' ? 'cursor-pointer' : ''">
                  <span class="text-white">{{!mini ? nivelUsuario : nivelUsuarioApelido}}</span>
                </div>
              </template>
              <span>Nível do usuário</span>
            </v-tooltip>
          </div>
        </div>
        <!-- v-else -->
        <!-- <div class="text-center">
          <img class="menu__open" @click.stop="toggleMenu()" v-if="!mini" src="./assets/img/logo-white.png" alt="Logo">
          <img class="menu__icon" v-if="mini" src="./assets/img/logo-white-icon.png" alt="Logo">
        </div> -->
      </div>
      <v-list expand dense>
        <v-list-item link to="/" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['dashboard:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>assessment</v-icon>
              </v-list-item-icon>
            </template>
            <span>Dashboard</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/tarefas" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['tarefas:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>list_alt</v-icon>
              </v-list-item-icon>
            </template>
            <span>Tarefas</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Tarefas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
          v-model="subgroupProd"
          append-icon="keyboard_arrow_down"
          v-if="$root.Permissions.validate(['produtos:visualizar'])"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-icon v-bind="attrs" v-on="on">
                  <v-icon>solar_power</v-icon>
                </v-list-item-icon>
              </template>
              <span>Produtos</span>
            </v-tooltip>
            <v-list-item-content @click.stop="subgroupProd = !subgroupProd">
              <v-list-item-title>Produtos</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item link to="/configuracoes/categorias" @click.stop="toggleMenu()"
            v-if="$root.Permissions.validate(['categorias-de-produtos:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Categorias</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/produtos" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['produtos:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Produtos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- v-if="$root.Permissions.validate(['kits-de-produtos:visualizar'])" -->
          <v-list-item link to="/configuracoes/kits" @click.stop="toggleMenu()">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Kits</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/marcas" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['marcas-de-produtos:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Marcas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/modelos" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['modelos-de-produtos:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Modelos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item link to="/documentos" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['documentos:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>snippet_folder</v-icon>
              </v-list-item-icon>
            </template>
            <span>Documentos</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Documentos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/financiamento" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['financiamento:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>currency_exchange</v-icon>
              </v-list-item-icon>
            </template>
            <span>Financiamento</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Financiamento</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/distribuidores" @click.stop="toggleMenu()"
          v-if="!$root.Permissions.distributor() && $root.Permissions.validate(['lista-de-distribuidores:visualizar'])"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>factory</v-icon>
              </v-list-item-icon>
            </template>
            <span>Distribuidores</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Distribuidores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/contatos" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['contatos:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>contact_phone</v-icon>
              </v-list-item-icon>
            </template>
            <span>Contatos</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Contatos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/instagram-imagens" @click.stop="toggleMenu()"
          v-if="$root.Permissions.validate(['pacotes-de-publicidades:visualizar'])"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>linked_camera</v-icon>
              </v-list-item-icon>
            </template>
            <span>Publicidades para Instagram</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Publicidades para Instagram</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/relatorios" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['relatorios:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>content_paste_search</v-icon>
              </v-list-item-icon>
            </template>
            <span>Relatórios</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Relatórios</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
          v-model="subgroupOrc"
          append-icon="keyboard_arrow_down"
          v-if="!$root.Permissions.distributor() && !$root.Permissions.revendor() && $root.Permissions.validate(['oportunidades:visualizar'])"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-icon v-bind="attrs" v-on="on">
                  <v-icon>emoji_objects</v-icon>
                </v-list-item-icon>
              </template>
              <span>Oportunidades</span>
            </v-tooltip>
            <v-list-item-content @click.stop="subgroupOrc = !subgroupOrc">
              <v-list-item-title>Oportunidades</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item link to="" @click.stop="toggleMenu(), openCloseDialog()" v-if="$root.Permissions.validate(['nova-oportunidade:visualizar']) && $root.Permissions.integrator()">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Nova oportunidade</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/oportunidades/aberto" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['oportunidades-abertas:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Em aberto</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/oportunidades/fechadas" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['oportunidades-fechadas:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Fechadas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/oportunidades/perdidas" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['oportunidades-perdidas:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Perdidas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item link to="/orcamentos" @click.stop="toggleMenu()"
          v-if="!$root.Permissions.distributor() && !$root.Permissions.revendor() && $root.Permissions.validate(['orcamentos:visualizar'])"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>request_page</v-icon>
              </v-list-item-icon>
            </template>
            <span>Orçamentos</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Orçamentos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
          v-model="subgroupGest"
          append-icon="keyboard_arrow_down"
          v-if="!$root.Permissions.integrator() && $root.Permissions.validate(['gestor:visualizar'])"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-icon v-bind="attrs" v-on="on">
                  <v-icon>engineering</v-icon>
                </v-list-item-icon>
              </template>
              <span>Gestor</span>
            </v-tooltip>
            <v-list-item-content @click.stop="subgroupGest = !subgroupGest">
              <v-list-item-title>Gestor</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item link to="/gestor/distribuidores" @click.stop="toggleMenu()"
            v-if="$root.Permissions.admin() && $root.Permissions.validate(['distribuidores:visualizar'])"
          >
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Distribuidores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/gestor/revendedores" @click.stop="toggleMenu()"
            v-if="!$root.Permissions.integrator() && !$root.Permissions.revendor() && $root.Permissions.validate(['revendedores:visualizar'])"
          >
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Revendedores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/gestor/integradores" @click.stop="toggleMenu()"
            v-if="!$root.Permissions.integrator() && $root.Permissions.validate(['integradores:visualizar'])"
          >
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Integradores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/auditoria" @click.stop="toggleMenu()"
            v-if="!$root.Permissions.integrator() && $root.Permissions.validate(['auditoria:visualizar'])"
          >
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Auditoria</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group
          v-model="subgroupConf"
          append-icon="keyboard_arrow_down"
          v-if="$root.Permissions.validate(['configuracoes:visualizar'])"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-icon v-bind="attrs" v-on="on">
                  <v-icon>settings</v-icon>
                </v-list-item-icon>
              </template>
              <span>Configurações</span>
            </v-tooltip>
            <v-list-item-content @click.stop="subgroupConf = !subgroupConf">
              <v-list-item-title>Configurações</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item link @click.stop="openDialogDadosCadastrais()" v-if="!$root.Permissions.admin() && $root.Permissions.validate(['dados-cadastrais-da-empresa:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Dados cadastrais</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/grupos" @click.stop="toggleMenu()" v-if="!$root.Permissions.integrator() && !$root.Permissions.revendor() && $root.Permissions.validate(['grupos-de-usuarios:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Grupos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/usuarios" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['usuarios:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Usuários</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/template-proposta" @click.stop="toggleMenu()"
            v-if="$root.Permissions.integrator() && $root.Permissions.validate(['template-de-proposta:visualizar'])"
          >
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Template de proposta</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/opcoes-financiamento" @click.stop="toggleMenu()"
            v-if="$root.Permissions.integrator() && $root.Permissions.validate(['opcoes-base-de-financiamento:visualizar'])"
          >
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Opções base de financiamento</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/tipos-estrutura" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['tipos-de-estrutura:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Tipos de estrutura</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/parceiros" @click.stop="toggleMenu()"
            v-if="$root.Permissions.validate(['parceiros:visualizar'])"
          >
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Parceiros</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/bancos" @click.stop="toggleMenu()"
            v-if="!$root.Permissions.distributor() && !$root.Permissions.revendor() && $root.Permissions.validate(['bancos-e-financeiras:visualizar'])"
          >
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Bancos e financeiras</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/funil-de-oportunidades" @click.stop="toggleMenu()"
            v-if="$root.Permissions.integrator() && $root.Permissions.validate(['funil-de-oportunidades:visualizar'])"
          >
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Funil de oportunidades</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/banners" @click.stop="toggleMenu()" v-if="!$root.Permissions.integrator() && !$root.Permissions.revendor() && $root.Permissions.validate(['banners:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Banners</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/instagram" @click.stop="toggleMenu()" v-if="!$root.Permissions.integrator() && !$root.Permissions.revendor() && $root.Permissions.validate(['criar-pacotes-de-publicidades:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Publicidades para Instagram</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <div class="versao">
        1.1.5
      </div>
    </v-navigation-drawer>
    <v-app-bar
      v-if="this.$route.name != 'Login' && this.$route.name != 'PropostaWeb' && this.$route.name != 'ExportPdf'"
      class="menu__toolbar"
      app
      :height="bgHeight"
      :absolute="true">
      <div class="w-100">
        <v-row no-gutters justify="end" align="center">
          <div class="mr-3 formBuscaArea">
            <v-form ref="formBusca" style="min-height: 40px">
              <!-- <v-text-field
                v-model="busca"
                outlined
                label="Busca"
                append-icon="search"
                hide-details="auto"
              ></v-text-field> -->
            </v-form>
          </div>
          <div class="mr-3">
            <v-row no-gutters align="center">
              <!-- <notificacao class="ui-btn-inherit ml-3"></notificacao> -->
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Bem-vindo, {{user ? user.usu_nome.length > 25 ? user.usu_nome.substring(0,25) + '...' : user.usu_nome : ''}}
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="dialogCadastro = true">
                    <v-list-item-icon class="mr-1">
                      <v-icon>manage_accounts</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Atualizar meu cadastro</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="dialogLogout = true">
                    <v-list-item-icon class="mr-1">
                      <v-icon>logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Sair</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </div>
        </v-row>
      </div>
      <v-dialog
        v-model="dialogDadosCadastrais"
        persistent
        max-width="600px"
      >
        <v-card class="ui-dialog-top">
          <v-row no-gutters align="center" justify="space-between">
            Dados cadastrais
            <v-icon @click="dialogDadosCadastrais = false">close</v-icon>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <v-form ref="formEmpresa">
            <v-row>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                <v-text-field
                  v-model="empresa.emp_nome_fantasia"
                  label="Nome Fantasia*"
                  :rules="[rules.required]"
                  autofocus
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                <v-text-field
                  v-model="empresa.emp_nome"
                  label="Razão social*"
                  :rules="[rules.required]"
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                <v-text-field-cnpj
                  v-model="empresa.emp_cnpj"
                  label="CNPJ*"
                  :rules="[rules.required]"
                  v-bind:properties="{
                    loading: salvando,
                    disabled: salvando,
                    outlined: true,
                    clearable: true,
                    placeholder: '',
                  }"
                  v-bind:options="{
                    outputMask: '##############',
                    empty: null,
                    applyAfter: false,
                  }"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                <v-text-field
                  outlined
                  label="Telefone*"
                  :rules="[rules.required]"
                  v-model="empresa.emp_telefone"
                  v-mask="'(##) #####-####'"
                  :loading="salvando"
                  :disabled="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="empresa.emp_email"
                  label="E-mail*"
                  :rules="[rules.required, rules.email]"
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                <v-text-field-cep
                  v-model="empresa.emp_cep"
                  label="CEP*"
                  :rules="[rules.required]"
                  @change="searchCep(empresa.emp_cep)"
                  v-bind:properties="{
                    loading: loadingCep || salvando,
                    disabled: loadingCep || salvando,
                    outlined: true,
                    clearable: true,
                    placeholder: '',
                  }"
                  v-bind:options="{
                    outputMask: '########',
                    empty: null,
                    applyAfter: false,
                  }"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                <v-autocomplete
                  v-model="empresa.emp_uf"
                  autocomplete="off"
                  :items="estados"
                  :rules="[rules.required]"
                  :loading="salvando || loadingEstados || loadingCep"
                  :disabled="salvando || loadingEstados || loadingCep"
                  label="Estado*"
                  append-icon="expand_more"
                  outlined
                  @change="filterCidade(empresa.emp_uf)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                <v-autocomplete
                  autocomplete="off"
                  v-model="empresa.emp_cidade"
                  :items="cidadesFiltradas"
                  :loading="salvando || loadingCidades || loadingCep"
                  :disabled="salvando || loadingCidades || loadingCep"
                  label="Cidade*"
                  :rules="[rules.required]"
                  append-icon="expand_more"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="empresa.emp_bairro"
                  outlined
                  :rules="[rules.required]"
                  :loading="salvando || loadingCep"
                  :disabled="salvando || loadingCep"
                  label="Bairro*"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="9" lg="9" xl="9" class="pb-0 pt-0">
                <v-text-field
                  v-model="empresa.emp_rua"
                  outlined
                  :loading="salvando || loadingCep"
                  :disabled="salvando || loadingCep"
                  :rules="[rules.required]"
                  label="Rua*"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="empresa.emp_numero"
                  outlined
                  :loading="salvando || loadingCep"
                  :rules="[rules.required]"
                  :disabled="salvando || loadingCep"
                  label="Número*"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="empresa.emp_complemento"
                  outlined
                  :loading="salvando || loadingCep"
                  :disabled="salvando || loadingCep"
                  label="Complemento"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-divider></v-divider>
          <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
            <v-btn
              color="cancel"
              :loading="salvando"
              :disabled="salvando"
              @click="dialogDadosCadastrais = false"
            >
              Fechar
            </v-btn>
            <v-btn
              color="primary"
              @click="editarDadosCadastrais()"
              :loading="salvando"
              :disabled="salvando"
            >
              Alterar
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogCadastro"
        persistent
        max-width="400px"
      >
        <v-card class="ui-dialog-top">
          <v-row no-gutters align="center" justify="space-between">
            Atualizar meu cadastro
            <v-icon @click="closeDialogUsuario()">close</v-icon>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <v-form ref="formCadastro">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
                <v-text-field
                  v-model="usuario.usu_nome"
                  label="Nome*"
                  :rules="[rules.required]"
                  autofocus
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="usuario.usu_email"
                  label="E-mail*"
                  :rules="[rules.required, rules.email]"
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0">
                <v-text-field
                  v-model="usuario.usu_apelido"
                  label="Usuário*"
                  :rules="[rules.required]"
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0">
                <v-text-field
                  outlined
                  label="Telefone"
                  v-model="usuario.usu_telefone"
                  v-mask="'(##) #####-####'"
                  :loading="salvando"
                  :disabled="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0">
                <v-text-field
                  @click:append="show1 = !show1"
                  :label="usuario.uuid_usu_id ? 'Preencha caso desejar alterar a senha' : 'Senha*'"
                  hint="Mínimo 6 caracteres"
                  counter
                  outlined
                  :loading="salvando"
                  :disabled="salvando"
                  :type="show1 ? 'text' : 'password'"
                  v-model="usuario.password"
                  :append-icon="show1 ? 'remove_red_eye' : 'visibility_off'"
                  :rules="usuario.uuid_usu_id ? [] : [rules.required, rules.min]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
                <v-file-input
                  show-size
                  clearable
                  ref="file"
                  v-model="usuario.usu_imagem"
                  prepend-icon="image"
                  label="Adicionar imagem"
                  clear-icon="close"
                  truncate-length="50"
                  :loading="salvando"
                  :disabled="salvando"
                  v-if="isObject(usuario.usu_imagem)"
                  outlined
                ></v-file-input>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="usuario.usu_imagem && !isObject(usuario.usu_imagem)">
                <v-row no-gutters justify="start" align="center">
                  <div>
                    <div class="avatar" :style="`background-image: url('${usuario && usuario.usu_imagem ? usuario.usu_imagem : require('@/assets/img/logo-icon.png')}')`"></div>
                  </div>
                  <div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                      </template>
                      <span>Remover imagem</span>
                    </v-tooltip>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
          <v-divider></v-divider>
          <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
            <v-btn
              color="cancel"
              :loading="salvando"
              :disabled="salvando"
              @click="closeDialogUsuario()"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              @click="editUser()"
              :loading="salvando"
              :disabled="salvando"
            >
              Salvar
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDeletarImagem" max-width="400">
        <v-card class="ui-dialog-top">
          <v-row align="center" justify="space-between">
            <v-col cols="10">
              Remover Imagem
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon @click="dialogDeletarImagem = false">close</v-icon>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <div class="mb-5">
            Tem certeza que deseja remover a imagem?
          </div>
          <v-divider class="mb-3"></v-divider>
          <v-row
            align="center"
            justify="space-between"
            class="px-5 py-5"
          >
            <v-btn
              color="cancel"
              :loading="salvando"
              :disabled="salvando"
              @click="dialogDeletarImagem = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="success"
              :loading="salvando"
              :disabled="salvando"
              @click="removeImagem()"
            >
              Remover
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogLogout" max-width="450">
        <v-card class="ui-dialog-top">
          <v-row align="center" justify="space-between">
            <v-col cols="10">
              Tem certeza que deseja sair?
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon @click="dialogLogout = false">close</v-icon>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <v-row
            align="center"
            justify="space-between"
            class="px-5 py-5"
          >
            <v-btn
              color="cancel"
              :disabled="logoutLoading"
              :loading="logoutLoading"
              @click="dialogLogout = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="success"
              :disabled="logoutLoading"
              :loading="logoutLoading"
              @click="logout()"
            >
              Sair
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
    </v-app-bar>
    <v-main :class="this.$route.name != 'Login' && this.$route.name != 'PropostaWeb' && this.$route.name != 'ExportPdf' ? 'main__home' : ''">
      <div id="app" class="h-100" @click="checkMenuOpen()">
        <transition name="route-fade" mode="out-in">
          <router-view/>
        </transition>
      </div>
      <v-tooltip right v-if="this.$route.name != 'PropostaWeb' && this.$route.name != 'ExportPdf'">
        <template v-slot:activator="{ on, attrs }">
          <div class="theme" v-bind="attrs" v-on="on">
            <v-icon @click="setTheme" v-if="!theme">brightness_5</v-icon>
            <v-icon @click="setTheme" v-else>brightness_4</v-icon>
          </div>
        </template>
        <span>Alterar tema</span>
      </v-tooltip>
    </v-main>
    <nova-oportunidade v-if="this.user" v-on:cancelar-close="openCloseDialog()" :abrir_dialog="dialogProposta"></nova-oportunidade>
    <snack-bar v-if="toggleSnack" />
    <printer :control="togglePrinter" />
  </v-app>
</template>

<script>
import SnackBar from '@components/SnackBar.vue'
import Printer from '@components/Printer.vue'
import Api from '@API'
import Notificacao from './pages/Notificacao.vue'
import axios from 'axios'
import NovaOportunidade from './pages/oportunidades/NovaOportunidade.vue'
export default {
  components: {SnackBar, Notificacao, Printer, NovaOportunidade},
  data () {
    return {
      theme: false,
      drawer: true,
      mini: true,
      bgHeight: '60',
      busca: '',
      dialogCadastro: false,
      dialogLogout: false,
      user: '',
      logoutLoading: false,
      subgroupConf: false,
      subgroupOrc: false,
      subgroupGest: false,
      subgroupProd: false,
      dialogDadosCadastrais: false,
      salvando: false,
      loadingCep: false,
      loadingEstados: false,
      loadingCidades: false,
      estados: [],
      cidades: [],
      cidadesFiltradas: [],
      dialogProposta: false,
      dialogDeletarImagem: false,
      nivelUsuarioApelido: '',
      nivelUsuario: '',
      show1: false,
      usuario: {
        uuid_gru_id: '',
        usu_nome: '',
        usu_email: '',
        usu_apelido: '',
        usu_telefone: '',
        usu_imagem: '',
        password: ''
      },
      empresa: {
        emp_nome_fantasia: '',
        emp_nome: '',
        emp_cep: '',
        emp_rua: '',
        emp_cnpj: '',
        emp_numero: '',
        emp_telefone: '',
        emp_complemento: '',
        emp_email: '',
        emp_bairro: '',
        emp_uf: '',
        emp_cidade: ''
      },
      prefix: null,
      rules: {
        required: value => !!value || 'Obrigatório.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'E-mail inválido.'
        }
      }
    }
  },
  methods: {
    openCloseDialog () {
      this.dialogProposta = !this.dialogProposta
      return this.dialogProposta
    },
    toggleMenu () {
      this.mini = !this.mini
      this.subgroupConf = false
      this.subgroupOrc = false
      this.subgroupGest = false
      this.subgroupProd = false
    },
    setTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      this.theme = this.$vuetify.theme.dark
      localStorage.setItem('darkTheme', this.$vuetify.theme.dark.toString())
    },
    checkMenuOpen () {
      if (!this.mini) {
        this.toggleMenu()
      }
    },
    updateData () {
      if (this.$route.name !== 'PropostaWeb' && this.$route.name !== 'Login' && this.$route.name !== 'ExportPdf') {
        if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
          this.user = JSON.parse(localStorage.getItem('user'))
          this.usuario = this.user
          if (this.user.fk_gru_id_grupo) {
            this.nivelUsuario = 'Master'
            this.nivelUsuarioApelido = 'M'
          }
          if (this.user.fk_dis_id_distribuidor) {
            this.nivelUsuario = 'Distribuidor'
            this.nivelUsuarioApelido = 'D'
          }
          if (this.user.fk_rev_id_revendedor) {
            this.nivelUsuario = 'Revendedor'
            this.nivelUsuarioApelido = 'R'
          }
          if (this.user.fk_int_id_integrador) {
            this.nivelUsuario = 'Integrador'
            this.nivelUsuarioApelido = 'I'
          }
        }
      }
    },
    logout () {
      this.logoutLoading = true
      Api.post('usuario/logout')
        .then(res => {
          console.log(res)
          this.dialog = false
          localStorage.removeItem('userData')
          localStorage.removeItem('user')
          localStorage.removeItem('token')
          this.dialogLogout = false
          this.logoutLoading = false
          this.user = null
          this.$router.push({ name: 'Login' }).catch(() => {})
        })
        .catch(err => {
          this.dialogLogout = false
          this.logoutLoading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao efetuar o logout!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openDialogDadosCadastrais () {
      if (!this.user.uuid_int_id && !this.user.uuid_dis_id && !this.user.uuid_rev_id) return
      this.salvando = true
      this.dialogDadosCadastrais = true
      this.toggleMenu()

      let endpoint = ''
      if (this.user.uuid_int_id) {
        endpoint = `integradores/${this.user.uuid_int_id}`
      }
      if (this.user.uuid_dis_id) {
        endpoint = `distribuidores/${this.user.uuid_dis_id}`
      }
      if (this.user.uuid_rev_id) {
        endpoint = `revendedores/${this.user.uuid_rev_id}`
      }

      Api.get(endpoint)
        .then(async res => {
          if (!res.data) {
            this.salvando = false
            this.dialogDadosCadastrais = false
            this.$root.SnackControl.open(this, {
              text: 'Ops, ocorreu um erro ao buscar os dados da empresa!',
              color: 'error'
            })
            return false
          }

          const empresa = res.data
          const prefix = empresa.uuid_int_id ? 'int' : empresa.uuid_dis_id ? 'dis' : 'rev'
          this.prefix = prefix

          this.empresa = {
            emp_uuid: empresa[`uuid_${prefix}_id`],
            emp_nome: empresa[`${prefix}_nome`],
            emp_nome_fantasia: empresa[`${prefix}_nome_fantasia`],
            emp_cep: empresa[`${prefix}_cep`],
            emp_rua: empresa[`${prefix}_rua`],
            emp_cnpj: empresa[`${prefix}_cnpj`],
            emp_numero: empresa[`${prefix}_numero`],
            emp_telefone: empresa[`${prefix}_telefone`],
            emp_complemento: empresa[`${prefix}_complemento`],
            emp_email: empresa[`${prefix}_email`],
            emp_bairro: empresa[`${prefix}_bairro`],
            emp_uf: empresa[`${prefix}_uf`],
            emp_cidade: empresa[`${prefix}_cidade`]
          }
          await this.filterCidade(this.empresa.emp_uf)
          this.salvando = false
        })
        .catch(err => {
          this.salvando = false
          this.dialogDadosCadastrais = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados da empresa!',
            color: 'error'
          })
        })
    },
    editarDadosCadastrais () {
      this.salvando = true
      const empresa = {
        [`uuid_${this.prefix}_id`]: this.empresa.emp_uuid,
        [`${this.prefix}_nome`]: this.empresa.emp_nome,
        [`${this.prefix}_nome_fantasia`]: this.empresa.emp_nome_fantasia,
        [`${this.prefix}_cep`]: this.empresa.emp_cep,
        [`${this.prefix}_rua`]: this.empresa.emp_rua,
        [`${this.prefix}_cnpj`]: this.empresa.emp_cnpj,
        [`${this.prefix}_numero`]: this.empresa.emp_numero,
        [`${this.prefix}_telefone`]: this.empresa.emp_telefone,
        [`${this.prefix}_complemento`]: this.empresa.emp_complemento,
        [`${this.prefix}_email`]: this.empresa.emp_email,
        [`${this.prefix}_bairro`]: this.empresa.emp_bairro,
        [`${this.prefix}_uf`]: this.empresa.emp_uf,
        [`${this.prefix}_cidade`]: this.empresa.emp_cidade
      }

      let endpoint = 'integradores/edita'
      if (this.user.uuid_dis_id) {
        endpoint = 'distribuidores/edita'
      }
      if (this.user.uuid_rev_id) {
        endpoint = 'revendedores/edita'
      }

      Api.post(endpoint, empresa)
        .then(async res => {
          this.salvando = false
          this.dialogDadosCadastrais = false
          this.$root.SnackControl.open(this, {
            text: 'Dados cadastrais da empresa alterados com sucesso!',
            color: 'success'
          })
        })
        .catch(err => {
          this.salvando = false
          this.dialogDadosCadastrais = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao editar os dados da empresa!',
            color: 'error'
          })
        })
    },
    removeImagem () {
      this.usuario.usu_imagem = ''
      this.usuario.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    editUser () {
      if (!this.$refs.formCadastro.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      if (this.$refs.file) {
        this.usuario.imagem = this.$refs.file.fileRecords
      }
      const formData = new FormData()
      Object.keys(this.usuario).map((key) => {
        if (key === 'imagem') {
          if (this.$refs.file) {
            if (this.$refs.file.fileRecords && this.$refs.file.fileRecords.length > 0) {
              formData.append(`imagem`, this.usuario.usu_imagem[0].file)
            }
          }
        } else {
          if (this.usuario[key] != null) {
            formData.append(key, this.usuario[key])
          }
        }
      })
      Api.post('usuarios/edita', formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialogUsuario()
          this.user = response.data
          this.usuario = response.data
          localStorage.setItem('user', JSON.stringify(response.data))
          this.$root.SnackControl.open(this, {
            text: 'Usuário atualizado com sucesso!',
            color: 'success'
          })
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    closeDialogUsuario () {
      if (this.$refs.formCadastro) {
        this.$refs.formCadastro.resetValidation()
      }
      this.dialogCadastro = false
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    loadFunctions () {
      this.getCidade()
      this.getEstados()
    },
    searchCep (cep = '') {
      if (cep.length === 8) {
        this.loadingCep = true
        axios.get('https://viacep.com.br/ws/' + cep + '/json/')
          .then((response) => {
            if (!response.data.erro) {
              this.empresa.emp_rua = response.data.logradouro
              this.empresa.emp_bairro = response.data.bairro
              this.empresa.emp_complemento = response.data.complemento
              if (response.data.uf) {
                this.empresa.emp_uf = response.data.uf
                this.empresa.emp_cidade = response.data.localidade
                this.filterCidade(response.data.uf)
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.$root.SnackControl.open(this, {
              text: 'Erro ao buscar por CEP!',
              color: 'error'
            })
          }).finally(() => {
            this.loadingCep = false
          })
      }
    },
    getEstados () {
      this.loadingEstados = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then((response) => {
          for (let estado = 0; estado < response.data.length; estado++) {
            this.estados.push({
              text: response.data[estado].nome,
              value: response.data[estado].sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os estados!',
            color: 'error'
          })
        })
      this.loadingEstados = false
    },
    getCidade () {
      this.loadingCidades = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios')
        .then((response) => {
          for (let cidade = 0; cidade < response.data.length; cidade++) {
            this.cidades.push({
              text: response.data[cidade].nome,
              value: response.data[cidade].nome,
              uf: response.data[cidade].microrregiao.mesorregiao.UF.sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar as cidades!',
            color: 'error'
          })
        })
      this.loadingCidades = false
    },
    async filterCidade (estado) {
      this.cidadesFiltradas = this.cidades.filter(city => city.uf === estado)
    }
  },
  computed: {
    toggleSnack () {
      return this.$root.snackbar.show
    },
    togglePrinter () {
      return this.$root.printerControl.show
    },
    abrir_dialog () {
      return this.openCloseDialog()
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    const theme = localStorage.getItem('darkTheme')
    if (theme) {
      if (theme === 'true') {
        this.$vuetify.theme.dark = true
        this.theme = true
      } else {
        this.$vuetify.theme.dark = false
        this.theme = false
      }
    } else if (
      window.matchMedia &&
       window.matchMedia('(prefers-color-scheme: dark)').matches
    ) {
      this.$vuetify.theme.dark = true
      localStorage.setItem(
        'darkTheme',
        this.$vuetify.theme.dark.toString()
      )
    }
    this.$router.beforeEach((to, from, next) => {
      this.subgroupAdm = false
      next()
    })
    this.updateData()
    this.loadFunctions()
  }
}
</script>

<style lang="scss">
@import "@scss/app.scss";
.theme {
  bottom: 10px;
  left: 16px;
  position: fixed;
  z-index: 10;
}
.menu {
  &__icon {
    margin-top: 15px;
    max-width: 35px;
  }
  &__open {
    margin-top: 15px;
  }
}
@media (max-width: 767px){
  .formBuscaArea {
    display: none;
  }
}
.versao {
  bottom: -3px;
  font-size: 9px;
  left: 1px;
  margin-top: 2px;
  position: absolute;
}
.avatar {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 100%;
  height: 80px;
  margin-right: 15px;
  width: 80px;
}
.tipo {
  background: $primary;
  border-radius: 5px;
  cursor: default;
  font-size: 14px;
  line-height: normal;
  padding: 0px 5px;
  transition: all 0.3s;
  width: 40%;
}
.tipo_small {
  background: $primary;
  border-radius: 5px;
  cursor: default;
  font-size: 14px;
  left: 30px;
  line-height: normal;
  padding: 2px 5px 1px 5px;
  position: absolute;
  top: 35px;
  transition: all 0.3s;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
@media print {
  .menu__toolbar {
    display: none;
  }
  .menu {
    display: none;
  }
  .theme {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue